module.exports = __webpack_public_path__ + "static/media/test18_1.40b6698b.png";